// @flow
import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { Form, FormLabel } from 'types/form'

import type { FormParams } from '../../../types/form'

type FormsResponse = Promise<{
  count: number,
  results: Array<Form>,
}>

export async function getFormsAndDocuments(
  {
    page = 1,
    pageSize = 10,
    search = '',
    internal_only = 'false',
    without_internal = 'false',
    without_disabled = 'false',
  }: FormParams = {},
  requestParams: { signal?: AbortSignal } = {}
): FormsResponse {
  return await makeGetRequest(
    ApiBase +
      `/forms/with_pdf?page=${page}&page_size=${pageSize}&search=${search}&internal_only=${internal_only}&without_internal=${without_internal}&without_disabled=${without_disabled}`,
    requestParams
  )
}

export async function getForm(id: string): Promise<Form> {
  return await makeGetRequest(ApiBase + `/forms/${id}`)
}

export async function getFormLabels(): Promise<Array<FormLabel>> {
  return await makeGetRequest(ApiBase + '/forms/labels')
}
